import React from 'react';
import RichText from './RichText';
import { connect } from 'umi';
import { Layout } from 'tea-component';
import ChannelRank from './ChannelRank';
import CoreKeyMetrics from './CoreKeyMetrics';
import { useEffectiveTimeList } from './hooks';
import ContentBody from '@op/components/ContentBody';
import { WeeklyReportOverview } from '@op/operationLog/pages';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';

import './index.scss';
import CardLoading from '@op/components/CardLoading';
import useLanguage from '@op/hooks/useLanguage';
import WeeklyReportDateSelect from '../components/WeeklyDateSelect';
import { useAccountFilter } from '../hooks/useAccountFilter';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

function Overview({ gameInfo }: any) {
  const { formatMessage } = useLanguage();
  useInitBuriedPointInfo({ buriedPoint: WeeklyReportOverview });
  const {
    filter,
    loading,
    effectiveTime,
    setEffectiveTime,
    effectiveTimeList,
  } = useEffectiveTimeList({ gameInfo });
  const { exceptPrivateFilter, officialAccountsFilter } = useAccountFilter({
    gameInfo,
  });

  return (
    <Content className="dbo-page dbo-weekly-report-overview">
      <ContentBody
        className="dbo-weekly-report-overview-body"
        pageName={PAGE_NAME.OVERVIEW}
        parentPageName={PAGE_NAME.WEEKLY_REPORT}
        contentHeard={
          <Content.Header
            className="dbo-header"
            title={formatMessage({ id: PAGE_NAME.OVERVIEW })}
          ></Content.Header>
        }
      >
        <CardLoading loading={loading}>
          <div className="dbo-overview-filter">
            <WeeklyReportDateSelect
              defaultValue={effectiveTime}
              onChange={(value: any) => {
                setEffectiveTime(value);
              }}
              options={effectiveTimeList}
            ></WeeklyReportDateSelect>
          </div>

          {/* 核心预览-富文本 */}
          <RichText filter={filter}></RichText>

          {/* 核心指标周度追踪 */}
          <CoreKeyMetrics
            defaultProps={{ 
              organization: { organization: 'player' },
              exceptPrivateFilter,
              officialAccountsFilter,
              exceptKeywordFilter: { social_media_by_keyword: ["-99999"] }
            }}
            filter={filter}
          ></CoreKeyMetrics>

          {/* 渠道排名周度追踪 */}
          <ChannelRank filter={filter}></ChannelRank>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Overview);
